export const isWeekend = (dayName: string): boolean => {
  switch (dayName) {
    case 'сб':
    case 'вс':
      return true;
    case 'пн':
    case 'вт':
    case 'ср':
    case 'чт':
    case 'пт':
    default:
      return false;
  }
};
